/* eslint-disable indent */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import WmsButton from "../react/components/WmsButton/WmsButton";
import WmsCollapse from "../react/components/WmsCollapse/WmsCollapse";
import WmsDropdown from "../react/components/WmsDropdown/WmsDropdown";
import WmsInput from "../react/components/WmsInput/WmsInput";
import WmsConfirmModel from "../react/components/WmsConfirmModel/WmsConfirmModel";
import { default as WmsModel } from "../react/components/WmsModel/WmsModel";
import { default as WmsContainer } from "../react/components/WmsContainer/WmsContainer";
import { default as WmsCustomDateTimePicker } from "../react/components/WmsCustomDateTimePicker/WmsCustomDateTimePicker.jsx";
import { ArrayWms } from "./../../assets/ts/ArrayWms";
import { ObjectWms } from "./../../assets/ts/ObjectWms";
import * as GlobalService from "../react/global_services";
import { StringWms } from "../../assets/ts/StringWms";
import * as GridConfig from "./parcel-shipments-grid-configuration";
import * as ParcelShipmentsServices from "./parcel-shipments.services";
import "./parcel-shipments.scss";
import _ from "lodash";
interface Props {
    wmsSelector: string;
    gridId: string;
    sharedSearchOn: boolean;
    isSavedFilterUpdate: boolean;
    sharedFilterObject: any;
    windowId: any;
    onClearSearch: () => void;
    onClickForFilterToggle: () => void;
    onFilterDataSet: (objFilter: any) => void;
    onApplySavedFilter: (objFilter: any) => void;
    onManageFilter: (param_action: any, param_data: any) => void;
    carrierOptions: any;
    trackingInfo: any;
}

const kendoMultiSelectId = "DeliveryStatus";
declare var window: any;

const ParcelShipmentsSearch: React.FC<Props> = (incomingProps: Props): any => {
    const {
        wmsSelector = "",
        sharedSearchOn = false,
        isSavedFilterUpdate = false,
        sharedFilterObject = {},
        windowId = "",
        gridId = "",
        onClearSearch = (): void => {},
        onManageFilter = (param_action: any, param_data: any): void => {},
        onFilterDataSet = (filterObject: any): void => {},
        onApplySavedFilter = (filterObject: any): void => {},
        trackingInfo = [],
    } = incomingProps;
    const props = {
        ...incomingProps,
        wmsSelector,
        sharedSearchOn,
        isSavedFilterUpdate,
        sharedFilterObject,
        windowId,
        gridId,
        onClearSearch,
        onManageFilter,
        onFilterDataSet,
        onApplySavedFilter,
        trackingInfo,
    };

    const CustomLabels = GlobalService.getCustomLabels();
    const gridDomSelector = props.windowId ? "." + props.windowId + " #" + props.gridId : "#" + props.gridId;
    const CustomerOptions = GlobalService.getCustomerList(true);
    const [facilityOPtions, setFacilityOptions] = useState(GlobalService.getFacilityList(true));
    const [filterObject, setFilterObject] = useState(props.sharedFilterObject);
    const [showSearchTargetTooltip, setShowSearchTargetTooltip] = useState(false);
    const [isOpenSaveFilterModel, setIsOpenSaveFilterModel] = useState(false);
    const [newFilterTitle, setNewFilterTitle] = useState("");
    const [filterNameExist, setFilterNameExist] = useState(false);
    const [isOpenUpdateConfirmModel, setIsOpenUpdateConfirmModel] = useState(false);
    const [isOpenConfirmModel, setIsOpenConfirmModel] = useState(false);
    const [savedFilterIndex, setSavedFilterIndex] = useState(0);
    const [isClickSearchFilterToggle, setIsClickSearchFilterToggle] = useState(false);
    const parcelShipmentsGridHeaders = StringWms.convertSringToOption(window.translate("Shipments_GridHeaders"));
    const defaultColumns = GridConfig.applyParcelShipmentsDeliveryStatusFilterUi(
        GridConfig.getParcelShipmentsColumns(parcelShipmentsGridHeaders).columns
    );
    const allColumnList = GridConfig.applyParcelShipmentsDeliveryStatusFilterUi(
        GridConfig.getParcelShipmentsAllColumnList(parcelShipmentsGridHeaders)
    );
    const [currentFilterIndex, setCurrentFilterIndex] = useState(0);
    const [savedFilterList, setSavedFilterList] = useState([]);
    const [isMultiSelectInitialized, setIsMultiSelectInitialized] = useState(false);
    const [showToolTip, setshowToolTip] = useState(false);

    const [shipmentServices, setShipmentServices] = useState<any[]>([
        {
            id: 0,
            Description: "Unspecified",
            Code: "",
        },
    ]);
    const [searchByOptions] = useState([
        { label: "Actual Delivery Date", index: 0 },
        { label: "Estimated Delivery Date", index: 1 },
        { label: "Small Parcel Ship Date", index: 2 },
    ]);

    // Memoize the dataSource to prevent re-rendering
    const multiSelectDataSource = useMemo(
        () => [
            {
                id: "1",
                name: "Label Created",
                value: "labelCreated",
            },
            {
                id: "2",
                name: "Unknown",
                value: "unknown",
            },
            {
                id: "3",
                name: "Accepted",
                value: "accepted",
            },
            {
                id: "4",
                name: "In Transit",
                value: "inTransit",
            },
            {
                id: "5",
                name: "Delivered",
                value: "delivered",
            },
            {
                id: "6",
                name: "Exception",
                value: "exception",
            },
        ],
        []
    );
    const handleFilterChange = (event: any) => {
        let name = event.target.name;
        let value = event.target.value;
        if (event.target.name === "CustomerID") {
            handleCustomerChange(parseInt(event.target.value));
        } else if (event.target.name === "FacilityID") {
            value = value === "0" ? null : value;
        }
        if (name === "Carrier") {
            let tempObject = ArrayWms.findObjectByKey(props.carrierOptions, "Carrier", event.target.value);
            let serviceData = GlobalService.hideDeactivatedShipmentServices(value, tempObject.ShipmentServices);
            if (Array.isArray(serviceData.shipmentServices)) {
                serviceData.shipmentServices.unshift({
                    id: 0,
                    Description: "Unspecified",
                    Code: "",
                });
                setShipmentServices(serviceData.shipmentServices);
                setFilterObject((previousState) => ({
                    ...previousState,
                    CarrierService: "",
                }));
            } else {
                setShipmentServices([]);
            }
        }

        setFilterObject((previousState) => ({
            ...previousState,
            [name]: value,
        }));

        finalCallFilterChange2();
    };
    const handleCustomerChange = (CustomerID: any) => {
        var selectedCustomer = CustomerOptions.find((cus: any) => cus.id === CustomerID);
        if (selectedCustomer) {
            var customerFacilityIds = selectedCustomer.facilities;
            let allFacilities = GlobalService.getFacilityList(true);
            allFacilities = allFacilities.filter((f: any) => customerFacilityIds.includes(f.id) || f.id === 0);
            setFacilityOptions(allFacilities);
        } else {
            setFacilityOptions([]);
        }
    };

    let finalCallFilterChange = () => {
        props.onFilterDataSet(filterObject);
    };

    let finalCallFilterChange2 = GlobalService.useFCDebounce(finalCallFilterChange, 1000);

    // Memoize event handlers to prevent re-rendering
    const handleMultiSelectChange = useCallback(
        function (e) {
            let isStatusRemoved = false;
            let selectedVal = $(`#${kendoMultiSelectId}`).data("kendoMultiSelect").value();
            const checkbox = $(e).closest("input[type='checkbox']");
            const isChecked = checkbox.prop("checked");
            checkbox.prop("checked", !isChecked);
            let chkArr = $(`#DeliveryStatus_listbox input[type='checkbox']`);
            for (let i = 0; i < chkArr.length; i++) {
                const $item = $(chkArr[`${i}`]).closest(".k-list-item, li");
                if ($item.hasClass("k-selected") || $item.hasClass("k-state-selected")) {
                    $(chkArr[`${i}`]).prop("checked", true);
                } else {
                    $(chkArr[`${i}`]).prop("checked", false);
                    isStatusRemoved = true;
                }
            }
            setFilterObject((previousState) => ({
                ...previousState,
                DeliveryStatus: selectedVal.join(","),
            }));
            if (isStatusRemoved) {
                finalCallFilterChange2();
            }
        },
        [finalCallFilterChange2]
    );

    const handleMultiSelectClose = useCallback(
        function () {
            finalCallFilterChange2();
        },
        [finalCallFilterChange2]
    );

    const handleMultiSelectSelect = useCallback(
        function (e) {
            e.preventDefault();
            const item = e.item;
            const checkbox = $(item).find("input[type='checkbox']");
            const value = this.dataItem(item).value;
            const values = this.value();
            const index = values.indexOf(value);
            if (index === -1) {
                values.push(value);
                checkbox.prop("checked", true);
            } else {
                values.splice(index, 1);
                checkbox.prop("checked", false);
            }
            setFilterObject((previousState) => ({
                ...previousState,
                DeliveryStatus: values.join(","),
            }));

            // finalCallFilterChange2();
            this.value(values);
        },
        [
            // finalCallFilterChange2
        ]
    );

    const handleMultiSelectOpen = useCallback(function () {
        // Setup checkbox handlers when dropdown opens
        setTimeout(() => {
            setupCheckboxClickHandlers();
        }, 50);
    }, []);

    const handleMultiSelectDataBound = useCallback(
        function () {
            if (props.sharedFilterObject.DeliveryStatus) {
                const deliveryStatusValues = props.sharedFilterObject.DeliveryStatus.split(",").map((item: any) =>
                    item.trim()
                );
                $(`#${kendoMultiSelectId}`).data("kendoMultiSelect").value(deliveryStatusValues);

                // Update checkbox states to match the values
                updateCheckboxStates(deliveryStatusValues);
            }
            setTimeout(() => {
                setupCheckboxClickHandlers();
                setupChipRemoveHandlers();
            }, 100);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [props.sharedFilterObject.DeliveryStatus]
    );

    useEffect(() => {
        setSavedFilterList(ParcelShipmentsServices.getSaveParcelShipmentsFilterListMetaData());

        // Only initialize if not already initialized
        if (!isMultiSelectInitialized) {
            // Clean up existing Kendo MultiSelect if it exists
            const existingMultiSelect = $(`#${kendoMultiSelectId}`).data("kendoMultiSelect");
            if (existingMultiSelect) {
                existingMultiSelect.destroy();
            }

            // Initialize Kendo MultiSelect
            $(`#${kendoMultiSelectId}`).kendoMultiSelect({
                dataTextField: "name",
                dataValueField: "value",
                autoClose: false,
                itemTemplate:
                    "<input type='checkbox' class='option-input custom-checkbox' id='#:data.value#_tag' data-value='#:data.value#'/>" +
                    "<span class='delivery-status-pill #:data.value#'>#:data.name#</span>",
                tagTemplate:
                    "<span class='delivery-status-pill #:data.value#' id='#:data.value#_item'>#:data.name#</span>",
                change: handleMultiSelectChange,
                select: handleMultiSelectSelect,
                filter: "contains",
                close: handleMultiSelectClose,
                open: handleMultiSelectOpen,
                dataBound: handleMultiSelectDataBound,
                dataSource: multiSelectDataSource,
                height: 400,
            });

            // Add click event to caret-down icon
            $(`#${kendoMultiSelectId}`)
                .parent()
                .next(".fa-caret-down")
                .on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const multiSelect = $(`#${kendoMultiSelectId}`).data("kendoMultiSelect");
                    if (multiSelect) {
                        multiSelect.open();
                    }
                });

            // Setup checkbox click handlers after initialization
            setTimeout(() => {
                setupCheckboxClickHandlers();
                setupChipRemoveHandlers();
            }, 100);

            setIsMultiSelectInitialized(true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMultiSelectInitialized,
        handleMultiSelectChange,
        handleMultiSelectSelect,
        handleMultiSelectClose,
        handleMultiSelectOpen,
        handleMultiSelectDataBound,
        multiSelectDataSource,
    ]);

    useEffect(() => {
        if (props.isSavedFilterUpdate) {
            setSavedFilterList(ParcelShipmentsServices.getSaveParcelShipmentsFilterListMetaData());
        }
    }, [props.isSavedFilterUpdate]);

    useEffect(() => {
        return () => {
            $(document).off("click", `#${kendoMultiSelectId}_listbox input[type='checkbox']`);
            $(document).off("click", `#${kendoMultiSelectId}_taglist .k-chip-action`);
        };
    }, []);

    useEffect(() => {
        setFilterObject(props.sharedFilterObject);
        if (props.sharedFilterObject.DeliveryStatus) {
            const deliveryStatusMultiSelect = $(`#${kendoMultiSelectId}`).data("kendoMultiSelect");
            if (deliveryStatusMultiSelect) {
                const deliveryStatusValues = props.sharedFilterObject.DeliveryStatus.split(",").map((item: any) =>
                    item.trim()
                );
                deliveryStatusMultiSelect.value(deliveryStatusValues);

                // Update checkbox states to match the values
                updateCheckboxStates(deliveryStatusValues);
            }
        } else {
            const deliveryStatusMultiSelect = $(`#${kendoMultiSelectId}`).data("kendoMultiSelect");
            if (deliveryStatusMultiSelect) {
                deliveryStatusMultiSelect.value([]);
                // Update checkbox states to match the values
                updateCheckboxStates([]);
            }
        }
    }, [props.sharedFilterObject]);
    let updateCheckboxStates = (deliveryStatusValues: any) => {
        setTimeout(() => {
            const checkboxes = $(`#${kendoMultiSelectId}_listbox input[type='checkbox']`);
            checkboxes.each(function () {
                const checkbox = $(this);
                const value = checkbox.data("value") || checkbox.attr("id")?.replace("_tag", "");
                if (value && deliveryStatusValues.includes(value)) {
                    checkbox.prop("checked", true);
                } else {
                    checkbox.prop("checked", false);
                }
            });
        }, 50);
    };

    let setupCheckboxClickHandlers = () => {
        // Remove any existing handlers first
        $(document).off("click", `#${kendoMultiSelectId}_listbox input[type='checkbox']`);

        // Add click handler for checkboxes
        $(document).on("click", `#${kendoMultiSelectId}_listbox input[type='checkbox']`, function (e) {
            e.stopPropagation(); // Prevent dropdown item selection

            const checkbox = $(this);
            const value = checkbox.data("value") || checkbox.attr("id")?.replace("_tag", "");
            if (!value) return; // Safety check

            const multiSelect = $(`#${kendoMultiSelectId}`).data("kendoMultiSelect");
            if (multiSelect) {
                let currentValues = multiSelect.value() || [];
                if (!currentValues.includes(value)) {
                    currentValues.push(value);
                    // checkbox.prop("checked", true);
                } else {
                    // Remove value if selected
                    currentValues = currentValues.filter((v: any) => v !== value);
                    // checkbox.prop("checked", false);
                }
            }
        });
    };

    let setupChipRemoveHandlers = () => {
        const selector = `#${kendoMultiSelectId}_taglist .k-chip-action`;
        $(document).off("click", selector);
        $(document).on("click", selector, function (e) {
            e.preventDefault();
            e.stopPropagation();
            const value = $(this).closest(".k-chip").find(".delivery-status-pill").attr("id")?.replace("_item", "");
            const multiSelect = $(`#${kendoMultiSelectId}`).data("kendoMultiSelect");
            if (!multiSelect || !value) {
                return;
            }
            const currentValues = multiSelect.value() || [];
            const values = currentValues.filter((v: any) => v !== value);
            if (values.length !== currentValues.length) {
                multiSelect.value(values);
            }
            updateCheckboxStates(values);
            setFilterObject((previousState) => ({
                ...previousState,
                DeliveryStatus: values.join(","),
            }));
            finalCallFilterChange2();
        });
    };

    let clickForFilterToggle = () => {
        setIsClickSearchFilterToggle(true);
        props.onClickForFilterToggle();
    };
    let exitSaveFilterModel = () => {
        setIsOpenSaveFilterModel(false);
    };
    let onOpenSaveFilterModel = () => {
        setIsOpenSaveFilterModel(true);
        setNewFilterTitle("");
        setFilterNameExist(false);
    };
    let onSaveFilter = () => {
        if (!filterNameExist) {
            props.onManageFilter("saveFilter", newFilterTitle);
            exitSaveFilterModel();
        }
    };
    let handleFilterTitleChange = (e) => {
        let value = e.target.value;
        if (value.Description === "") {
            value = "";
        }

        var nameExists = false;
        // check duplicate title for case sensitive
        var exists = savedFilterList.findIndex(function (item) {
            return value.toLowerCase() === item.title.toLowerCase();
        });
        if (exists !== -1) {
            nameExists = true;
        }
        setNewFilterTitle(value);
        setFilterNameExist(nameExists);
    };
    let onOpenUpdateConfirmModel = (param_index) => {
        setIsOpenUpdateConfirmModel(true);
        setCurrentFilterIndex(param_index);
    };
    let onClearSaveFilter = (index) => {
        setIsOpenConfirmModel(true);
        setSavedFilterIndex(index);
    };
    let onYesRemoveSavedFilter = () => {
        ParcelShipmentsServices.clearSaveParcelShipmentsFilterListMetaData(savedFilterIndex);
        setIsOpenConfirmModel(false);
        setSavedFilterList(ParcelShipmentsServices.getSaveParcelShipmentsFilterListMetaData());
    };
    let ClickExit = () => {
        setIsOpenConfirmModel(false);
    };
    let onUseSaveFilter = (index) => {
        var objFilter = _.cloneDeep(savedFilterList[`${index}`]);
        objFilter.filterData.IndexOptionsFacilityId = filterObject.IndexOptionsFacilityId;

        var grid = $(gridDomSelector).data("kendoGrid");
        // Custom date parser to convert ISO date strings to Date objects
        function dateParser(key: string, value: any) {
            if (typeof value === "string") {
                // Simple ISO date check
                // eslint-disable-next-line security/detect-unsafe-regex
                const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/;
                if (isoDateRegex.test(value)) {
                    const date = new Date(value);
                    if (!isNaN(date.getTime())) {
                        return date;
                    }
                }
            }
            return value;
        }
        var gridConfig = JSON.parse(objFilter.columnData, dateParser);
        var tempObject: any;
        if (gridConfig.columns) {
            var fieldArray = gridConfig.columns.map((el) => el.field);
            var updateColumn = [];
            allColumnList.forEach((column) => {
                if (fieldArray.indexOf(column.field) !== -1) {
                    updateColumn.push(column);
                }
            });
            tempObject = ObjectWms.alignIndexesByProperty(gridConfig.columns, updateColumn, "field");
        } else {
            tempObject = ObjectWms.alignIndexesByProperty(gridConfig.columns, defaultColumns, "field");
        }

        tempObject = GridConfig.applyParcelShipmentsDeliveryStatusFilterUi(tempObject);

        if (grid) {
            grid.setOptions({
                columns: tempObject,
            });
            grid.dataSource.sort(gridConfig.sorts);
            grid.dataSource.filter(gridConfig.filters);
            setFilterObject(objFilter.filterData);
            props.onApplySavedFilter(objFilter.filterData);
        }
    };
    let onUpdateFilter = () => {
        setIsOpenUpdateConfirmModel(false);
        props.onManageFilter("updateFilter", currentFilterIndex);
    };
    let onCloseUpdateConfirmModel = () => {
        setIsOpenUpdateConfirmModel(false);
    };
    let showFilterTooltip = () => {
        setshowToolTip(true);
    };
    let hideFilterTooltip = () => {
        setshowToolTip(false);
    };
    return (
        <div
            className={`parcel-shipments-search new-layout-filter-wrapper
            ${isClickSearchFilterToggle ? " sectionToggled" : ""}
            `}
        >
            {props.trackingInfo !== null && showToolTip ? (
                <div className="wms-tooltip-content">
                    {window.translate("parcel_shipments_filter_section_disabled_tooltip")}
                </div>
            ) : (
                ""
            )}
            <div
                onMouseEnter={showFilterTooltip}
                onMouseLeave={hideFilterTooltip}
                className="filter"
                onClick={props.trackingInfo !== null ? () => {} : clickForFilterToggle}
            >
                <i className="fa fa-caret-left" aria-hidden="true"></i>
                <span>search filters</span>
            </div>
            <div className="search-fields-Wrapper">
                <div className="btn-section">
                    <WmsButton
                        label={window.translate("Label_Save_View")}
                        wmsSelector={props.wmsSelector + "SaveFilterButton"}
                        onClickFunc={onOpenSaveFilterModel}
                        icon="fa-plus"
                    />
                    <WmsButton
                        label={window.translate("Label_Clear_Filters")}
                        buttonType="yellow"
                        wmsSelector={props.wmsSelector + "ClearSearchButton"}
                        onClickFunc={props.onClearSearch}
                        icon="fa-minus"
                    />
                </div>
                {props.sharedSearchOn && (
                    <div className="title">
                        <b>{window.translate("Label_NOTE")}: </b>
                        <label>{window.translate("Label_Search_Applied_Filter")}</label>
                    </div>
                )}
                <div className="shipments-form-boxes-wrapper">
                    <div className={"shipments-form-boxes " + (props.sharedSearchOn ? "width-title" : "")}>
                        <div className="shipments-area-content">
                            {savedFilterList.length !== 0 && (
                                <WmsCollapse
                                    id={"search_collapse0"}
                                    headerLabel={window.translate("Label_Saved_Filter_List")}
                                    showCollapseText={false}
                                >
                                    <ul className="filter-list-block">
                                        {savedFilterList.map((data, index) => (
                                            <li className="filter-list" key={index}>
                                                <button
                                                    type="button"
                                                    className="title-text"
                                                    title={data.title}
                                                    tabIndex={0}
                                                    aria-label={data.title}
                                                >
                                                    {data.title}
                                                </button>
                                                <div className="wms-apply-btn">
                                                    <WmsButton
                                                        label={window.translate("RoleManager_Label_Update")}
                                                        buttonType="green"
                                                        wmsSelector={props.wmsSelector + "UpdateFilterButton"}
                                                        onClickFunc={() => onOpenUpdateConfirmModel(index)}
                                                        icon=""
                                                    />
                                                    <WmsButton
                                                        label={window.translate("Label_Apply")}
                                                        buttonType="green"
                                                        wmsSelector={props.wmsSelector + "ApplyFilterButton"}
                                                        onClickFunc={() => onUseSaveFilter(index)}
                                                        icon=""
                                                    />
                                                </div>
                                                <button
                                                    type="button"
                                                    className="clear-save-filter"
                                                    onClick={() => onClearSaveFilter(index)}
                                                    aria-label={window.translate("Label_Remove_Filter")}
                                                >
                                                    <i className="far fa-times-circle" aria-hidden="true"></i>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </WmsCollapse>
                            )}
                            <WmsCollapse
                                id={"search_collapse1"}
                                headerLabel={window.translate("Label_Filter_Multi_Search")}
                                showCollapseText={false}
                            >
                                <WmsInput
                                    id="SearchTarget"
                                    extraWrapperClass="full-width-input"
                                    inputName="SearchTarget"
                                    wmsSelector={props.wmsSelector + "SearchTarget"}
                                    value={filterObject.SearchTarget}
                                    onChangeFunc={handleFilterChange}
                                    onIconClick={() => {}}
                                    label={"Search For"}
                                    showIconAfterInput={true}
                                    icon="fa-search"
                                    onMouseEnterFunc={() => {
                                        setShowSearchTargetTooltip(true);
                                    }}
                                    onMouseLeaveFunc={() => {
                                        setShowSearchTargetTooltip(false);
                                    }}
                                    isAutoFocus={true}
                                />
                                {showSearchTargetTooltip && (
                                    <span className="search-hover-tooltip">
                                        {window.translate("Label_Filter_Multi_Search_Tooltip")}
                                    </span>
                                )}
                            </WmsCollapse>
                            <WmsCollapse
                                id={"search_collapse2"}
                                headerLabel={window.translate("Label_Date_Range")}
                                showCollapseText={false}
                            >
                                <WmsDropdown
                                    id="IndexOptionsSearchBy"
                                    name="IndexOptionsSearchBy"
                                    label={window.translate("Label_Filter_Search_By")}
                                    wmsSelector={props.wmsSelector + "SearchByOptions"}
                                    value={filterObject.IndexOptionsSearchBy}
                                    onChangeFunc={handleFilterChange}
                                    options={searchByOptions}
                                    textField="label"
                                    valueField="index"
                                    isHalfInput={true}
                                />

                                <WmsCustomDateTimePicker
                                    id={"StartDate"}
                                    name="StartDate"
                                    wmsSelector={props.wmsSelector + "DatePickerStartDate"}
                                    label={window.translate("Label_Begin")}
                                    onChangeFunc={handleFilterChange}
                                    value={filterObject.StartDate}
                                    windowId={props.windowId}
                                    isDateParseInCustomFormat={true}
                                />
                                <WmsCustomDateTimePicker
                                    id={"EndDate"}
                                    name="EndDate"
                                    wmsSelector={props.wmsSelector + "DatePickerEndDate"}
                                    label={window.translate("Label_End")}
                                    onChangeFunc={handleFilterChange}
                                    value={filterObject.EndDate}
                                    windowId={props.windowId}
                                    defaultTime={"23:59:59"}
                                    isDateParseInCustomFormat={true}
                                />
                            </WmsCollapse>
                            <WmsCollapse
                                id={"search_collapse3"}
                                headerLabel={window.translate("Label_Filter_Status")}
                                showCollapseText={false}
                            >
                                <div className="delivery-status-multiselect-wrapper">
                                    <label htmlFor={kendoMultiSelectId}>
                                        {window.translate("Label_Delivery_Status")}
                                    </label>
                                    <select
                                        id={kendoMultiSelectId}
                                        name={kendoMultiSelectId}
                                        style={{ width: "100%" }}
                                    ></select>
                                    <i className="fa fa-caret-down" aria-hidden="true"></i>
                                </div>
                            </WmsCollapse>
                            <WmsCollapse
                                id={"Label_General"}
                                showDragIcon={false}
                                headerLabel={window.translate("Label_General")}
                                showCollapseText={false}
                            >
                                <WmsDropdown
                                    id="search_warehouse"
                                    name="IndexOptionsFacilityId"
                                    label={CustomLabels.Label_Warehouse}
                                    wmsSelector={props.wmsSelector + "SelectWarehouse"}
                                    value={filterObject.IndexOptionsFacilityId}
                                    onChangeFunc={handleFilterChange}
                                    options={facilityOPtions}
                                    valueField="id"
                                    textField="name"
                                    parentClassName="form_group"
                                />
                                <WmsDropdown
                                    id="search_CustomerId"
                                    name="IndexOptionsCustomerId"
                                    label={CustomLabels.Label_Customer}
                                    wmsSelector={props.wmsSelector + "SelectCustomer"}
                                    value={filterObject.IndexOptionsCustomerId}
                                    onChangeFunc={handleFilterChange}
                                    options={CustomerOptions}
                                    textField={"name"}
                                    valueField={"id"}
                                />
                            </WmsCollapse>
                            <WmsCollapse
                                id={"Carrier_Detail"}
                                showDragIcon={false}
                                headerLabel={window.translate("Label_Carrier")}
                                showCollapseText={false}
                            >
                                <WmsDropdown
                                    id="Carrier"
                                    name="Carrier"
                                    label={window.translate("Label_Carrier")}
                                    wmsSelector={props.wmsSelector + "Carrier"}
                                    value={filterObject.Carrier}
                                    onChangeFunc={handleFilterChange}
                                    options={props.carrierOptions}
                                    textField={"DisplayName"}
                                    valueField={"Carrier"}
                                />
                                <WmsDropdown
                                    id="ShipService"
                                    name="ShipService"
                                    label={window.translate("Label_Service")}
                                    wmsSelector={props.wmsSelector + "ShipService"}
                                    value={filterObject.ShipService}
                                    onChangeFunc={handleFilterChange}
                                    options={shipmentServices}
                                    textField={"Description"}
                                    valueField={"Code"}
                                />
                            </WmsCollapse>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {isOpenSaveFilterModel && (
                    <WmsModel
                        id="saveCurrentFilter"
                        title={window.translate("Label_Save_Filter")}
                        width={450}
                        height={260}
                        onCloseFunc={exitSaveFilterModel}
                        isOpen={isOpenSaveFilterModel}
                        customClass="wms-model-new-ui-wrapper"
                    >
                        <div className="model-content-wrapper">
                            <WmsContainer>
                                <WmsInput
                                    inputName="newFilterTitle"
                                    name="newFilterTitle"
                                    wmsSelector={props.wmsSelector + "FilterTitle"}
                                    value={newFilterTitle}
                                    onChangeFunc={handleFilterTitleChange}
                                    extraWrapperClass="full-width-input"
                                    label={window.translate("Label_Filter_Title")}
                                />
                            </WmsContainer>
                        </div>
                        <div className="save-filter-button-wrapper footer-btn-holder">
                            <WmsButton
                                label={window.translate("Label_Close")}
                                wmsSelector={props.wmsSelector + "SaveNewFilterExit"}
                                onClickFunc={exitSaveFilterModel}
                                buttonType="orange"
                                icon={"fa-times-circle-o"}
                            />
                            <WmsButton
                                label={window.translate("Label_Add")}
                                wmsSelector={props.wmsSelector + "SaveNewFilter"}
                                onClickFunc={onSaveFilter}
                                disabled={newFilterTitle === "" || filterNameExist}
                                icon={"fa-plus"}
                                showToolTip={filterNameExist}
                                tooltipText={window.translate("Label_Filter_Name_Exist_Message")}
                            />
                        </div>
                    </WmsModel>
                )}
            </div>
            <WmsConfirmModel
                id={"ConfirmModel" + props.windowId}
                isOpen={isOpenConfirmModel}
                type={window.translate("Label_Confirmation")}
                width={500}
                height={175}
                firstBtnLabel={window.translate("Label_Yes")}
                firstBtnIcon={"fa-check-square"}
                firstBtnOnClickFunc={onYesRemoveSavedFilter}
                sawCheckBox={false}
                conFormModelText={window.translate("Label_are_you_sure_remove_filter")}
                onCloseFunc={ClickExit}
                thirdBtnLabel={window.translate("Label_No")}
                thirdBtnIcon={"fa-times-circle"}
            />
            <WmsConfirmModel
                id={"ConfirmUpdateModel" + props.windowId}
                isOpen={isOpenUpdateConfirmModel}
                type={window.translate("Label_Confirmation")}
                width={500}
                height={175}
                firstBtnLabel={window.translate("Label_Yes")}
                firstBtnIcon={"fa-check-square"}
                firstBtnOnClickFunc={onUpdateFilter}
                sawCheckBox={false}
                conFormModelText={window.translate("Label_are_you_sure_update_filter")}
                onCloseFunc={onCloseUpdateConfirmModel}
                thirdBtnLabel={window.translate("Label_No")}
                thirdBtnIcon={"fa-times-circle"}
                isLoadingStop={false}
            />
        </div>
    );
};
ParcelShipmentsSearch.propTypes = {
    wmsSelector: PropTypes.string.isRequired,
    sharedSearchOn: PropTypes.bool.isRequired,
    sharedFilterObject: PropTypes.any.isRequired,
    windowId: PropTypes.any.isRequired,
    onClearSearch: PropTypes.func.isRequired,
    onFilterDataSet: PropTypes.func.isRequired,
};

export default React.memo(ParcelShipmentsSearch);
